module.exports = __webpack_public_path__ + "img/avatar-23.f7724df8.png";